export default function formatMoney(value) {
  if (value || value === 0) {
    const amt = (Math.round(Number.parseFloat(value) * 100) / 100).toFixed(2)
    // .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')

    if (amt < 0) {
      return (
        '($' +
        ((amt &&
          Math.abs(amt)
            .toLocaleString(undefined, {
              maximumFractionDigits: 2,
            })
            .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')) ||
          '0') +
        ')'
      )
    }
    return (
      '$' +
      ((amt &&
        amt
          .toLocaleString(undefined, {
            maximumFractionDigits: 2,
          })
          .replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')) ||
        '0')
    )
  }
  // return Number.parseFloat(value).toFixed(2)
}
